import { useCallback, useEffect, useState } from "react";
import { Permissions } from "@evergis/api";

import { togglePermissions } from "../../../../utils/permissions";

import { CheckedEntities, PartialEntities } from "../types";

export const useTotal = (
  onBulkUpdate: (state: Permissions) => void,
  checkedAll: CheckedEntities | undefined,
  partial: PartialEntities | undefined,
  activeUser: string,
) => {
  const [totalPermissions, setTotalPermissions] = useState<Permissions | undefined>(undefined);

  // Обработка клика на общие переключатели типов доступа
  const onUpdateTotal = useCallback(
    (toggle: "read" | "write" | "configure") => {
      const updatedPermissions = togglePermissions(totalPermissions, toggle);

      setTotalPermissions(updatedPermissions);
      onBulkUpdate(updatedPermissions);
    },
    [onBulkUpdate, totalPermissions],
  );

  // Обновление общих настроек доступа в соответствии с выставленными настройками для всех вложенных сущностей
  useEffect(() => {
    if (checkedAll !== undefined && partial !== undefined && totalPermissions === undefined) {
      let result = [];

      if (checkedAll.read || partial.read) {
        result = [...result, "read"];
      }

      if (checkedAll.write || partial.write) {
        result = [...result, "write"];
      }

      if (checkedAll.configure || partial.configure) {
        result = [...result, "configure"];
      }

      setTotalPermissions((result.length ? result.join(",") : "none") as Permissions);
    }
  }, [checkedAll, partial, totalPermissions]);

  useEffect(() => {
    setTotalPermissions(undefined);
  }, [activeUser]);

  return { onUpdateTotal };
};
